import { Component, inject, input } from '@angular/core';
import { PropertyCard } from '../../shared/ui/property-card/property-card';
import { ResultsService } from '../../services/results.service';
import { SearchService } from '../../services/search.service';
import { GhostButton } from '../../shared/ui/ghost-button/ghost-button';

@Component({
  selector: 'app-results-grid',
  imports: [PropertyCard, GhostButton],
  templateUrl: './results-grid.html',
})
export class ResultsGrid {
  public readonly resultsService = inject(ResultsService);
  public readonly searchService = inject(SearchService);
}
